export default __webpack_public_path__ + "static/media/light-theme-vid-logo.e4fc412b.svg";